import { Component, Input, ViewEncapsulation, ViewChildren, OnInit } from '@angular/core';
import { configLineChart } from './line-chart.config';
import { BaseChartDirective } from 'ng2-charts';
import { TranslateService } from '@ngx-translate/core';
import { LineChartService } from './line-chart.service';
import { Observable } from 'rxjs/Observable';
import { LineChartResultData } from './line-chart';
import { LineChart } from './line-chart';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'cc-line-chart',
  templateUrl: './line-chart.component.html',
  styleUrls: ['./line-chart.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class LineChartComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private chartService: LineChartService,
    private languageService: LanguageService
  ) {}

  @ViewChildren(BaseChartDirective) charts: BaseChartDirective;

  @Input() results = new Observable<LineChart>();
  @Input() colors;
  @Input() config = configLineChart;
  public empty = true;
  public lineChartLabels: Array<any> = [];
  public resultToChart: LineChartResultData[];

  ngOnInit(): void {
    this.updateChartsLanguage();
    this.languageService.onLanguageChange.subscribe(() => {
      this.updateChartsLanguage();
    });
  }

  updateChartsLanguage() {
    this.results.subscribe(result => {
      this.chartService.translateChartLabel(result).subscribe(translatedTexts => {
        const [all, answered] = Object.values(translatedTexts);
        this.checkEmptyAndPrepare(result, {
          all,
          answered
        });
        this.lineChartLabels = this.chartService.updateChartXLabels(
          this.resultToChart[0].data.map(c => c.x),
          this.charts
        );
      });
    });
  }

  checkEmptyAndPrepare(result, translatedLabels) {
    this.empty = !!this.chartService.checkEmpty(result);
    if (this.empty) {
      const tempResult: LineChart = this.chartService.prepareChartOnEmptyData(translatedLabels);
      this.resultToChart = this.chartService.prepareChart(tempResult, translatedLabels);
    } else {
      this.resultToChart = this.chartService.prepareChart(result, translatedLabels);
    }
  }
}
